import React, { useEffect, useState } from 'react';
import HanTableCell from './HanTableCell';
import HanTableContainer from './HanTableContainer';
import HanTableHead from './HanTableHead';
import HanTableRow from './HanTableRow';

interface IProps {
    children: any;
    /**
     * @description Dashed border orientation in the table.
     */
    borderOrientation?: "horizontal" | "vertical",
    modifiers?: string | string[];
    className?: string;
}

/**
 * @description Place inside HanTableContainer.tsx
 * @param children Content of the HanTable. Place the component HanTableRow.tsx in here as many times as needed.
 * @param borderOrientation The dashed border inside of the table can be horizontal or vertical.
 * @param modifiers Possible modifiers: wrap
 * @param className
 */
const HanTable: React.FC<IProps> = ({ children, borderOrientation, modifiers, className }) => {
    const baseClassName = `han-table__table ${className ? className : ''}`;
    const [tableClassName, setClassName] = useState<string>(baseClassName);

    useEffect(() => {
        if(modifiers) {
            let classNameString = baseClassName;

            if(Array.isArray(modifiers)) {
                modifiers.forEach(modifier => {
                    classNameString += ` ${baseClassName}--${modifier}`;
                })
            } else {
                classNameString += ` ${baseClassName}--${modifiers}`;
            }
            
            setClassName(classNameString);
        }
    }, [modifiers, baseClassName])

    return (
        <div className="han-table__table-container">
            <table className={`${tableClassName} ${borderOrientation ? `han-table__table--${borderOrientation}` : ``}`}>
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    )
}

export default HanTable;

export {
    HanTableCell,
    HanTableContainer,
    HanTableHead,
    HanTableRow
}
